import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSkip5SecondsForward32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconSkip5SecondsForward32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.95 6.55a1 1 0 1 0-1.414 1.414L14.07 10.5H9a5 5 0 0 0-5 5V21a5 5 0 0 0 5 5h6a1 1 0 0 0 0-2H9a3 3 0 0 1-3-3v-5.5a3 3 0 0 1 3-3h5.071l-2.535 2.536a1 1 0 0 0 1.414 1.414l4.242-4.243a1 1 0 0 0 0-1.414zM24.5 20c1.098 0 1.991-.89 2-2.008C26.509 16.79 25.738 16 25 16c-.827 0-1.425.206-1.803.394a2.7 2.7 0 0 0-.492.316l-.008.007A1 1 0 0 1 21 16v-5.983h5.5a1 1 0 0 1 0 2H23v2.3A6.2 6.2 0 0 1 25 14c2.262 0 3.514 2.16 3.5 4.008-.017 2.196-1.784 3.992-4 3.992-.974 0-1.77-.324-2.309-.632a5 5 0 0 1-.816-.583l-.053-.05-.018-.017-.006-.006-.003-.003h-.001v-.001L22 20l-.707.707a1 1 0 1 1 1.423-1.406q.025.023.088.074c.084.068.213.162.38.257.336.192.79.368 1.316.368"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSkip5SecondsForward32);
